// extracted by mini-css-extract-plugin
module.exports = {"FontFamilyMain":"'Karla', sans-serif","ColorBrandPrimaryBase":"#d83f87","ColorBrandTertiaryBase":"#44318d"};